import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthLocalDevInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
  if ((environment as any)?.localDevAuthHeader) {
    const cloned = req.clone({
      setHeaders: {
        'X-Local-Dev-Auth': (environment as any).localDevAuthHeader
      }
    });
    return next.handle(cloned);
  }
  return next.handle(req);
  }
}